import { pushDatalayer } from '../utilities';

export default class FormDatalayer {
    constructor(el) {
        this.DOM = { el: el };
        this.formDatalayer = JSON.parse(this.DOM.el.dataset.formDatalayer || '{}');

        pushDatalayer(this.formDatalayer);
    }
}

const formDatalayerNodes = Array.from(document.querySelectorAll('[data-form-datalayer]'));
if (formDatalayerNodes !== null) {
    formDatalayerNodes.forEach((node) => { new FormDatalayer(node); });
}
